export const Raritygems = ({ rarity }) => {
  let rarityIcons = "";
  let rarityCount = 0;
  if (rarity <= 100) rarityCount = 5;
  else if (rarity > 100 && rarity <= 500) rarityCount = 4;
  else if (rarity > 500 && rarity <= 2500) rarityCount = 3;
  else if (rarity > 2500 && rarity <= 5000) rarityCount = 2;
  else rarityCount = 1;
  for (let i = 0; i < rarityCount; i++) {
    rarityIcons += "💎";
  }
  return <span>{rarityIcons}</span>;
};
